import type { ColumnTypeFn } from "../types";

export const timeType: ColumnTypeFn = (value) => {
  if (value == null) return <span className="text-muted">-</span>;
  return <>{String(value)}</>;
};
